import React, { useEffect, useState } from 'react'
import { Row, Col } from 'reactstrap'
import moment from 'moment-timezone'
import SweetAlert from 'react-bootstrap-sweetalert'
import {
  CDU_TYPE,
  AIR_TYPE,
  REFRIG_TYPE,
  REFRIG_CDU_TYPE,
  PERIOD, METER_TYPE
} from '@common/constants'

import PeriodSelector from '@components/PeriodSelector'
import Spinner from '@components/@vuexy/spinner/Fallback-spinner'
import HistoricalGraph from '@screens/EquipmentDetail/components/HistoricalGraph'
import HistoricalPanelRight from '@screens/EquipmentDetail/components/HistoricalPanelRight'
import { convertToDatetimeUTC } from "@common/utils"

import * as ShopApi from "@apis/shop"
import * as IotDataApi from '@apis/iotData'

import "@assets/scss/components/historicalTab.scss"
import '@assets/scss/plugins/forms/flatpickr/flatpickr.scss'
import 'flatpickr/dist/themes/light.css'

const HistoricalTab = (props) => {
    const [shopId, setShopId] = useState(null)
    const [fromDate, setFromDate] = useState(moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss'))
    const [toDate, setToDate] = useState(moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'))
    const [dataPeriod, setDataPeriod] = useState(PERIOD.HOURLY)

    const [averageData, setAverageData] = useState({})
    const [healthScoreDonutList, setHealthScoreDonutList] = useState([0, 0, 0, 0, 0])
    const [alertDataTreemapList, setAlertDataTreemapList] = useState(null)

    const [historicalData, setHistoricalData] = useState([])
    const [isLoading, setLoading] = useState(true)
    const [isFetchData, setFetchData] = useState(false)

    // SweetAlert
    const showAlert = (type, header, message, callback, showCancel = false) => {
        setAlertModel({
            isShow: true,
            header: header,
            message: message,
            type: type,
            callback: callback,
            showCancel: showCancel,
        })
    }

    const closeAlert = () => {
        setAlertModel({ isShow: false, callback: closeAlert })
    }

    const [errMsg, setErrMsg] = useState('')
    const [alertModel, setAlertModel] = useState({ isShow: false, callback: closeAlert })

    useEffect(() => {
        isFetchData && getHistoricalData(props.equipment.ukey)
    }, [isFetchData])

    useEffect(() => {
        if (props.shop) {
            setShopId(props.shop.id)
        }
    }, [props])

    const getHistoricalData = async (ukey) => {
        try {
            setLoading(true)
            const fromDateUTC = convertToDatetimeUTC(fromDate)
            const toDateUTC = convertToDatetimeUTC(toDate)

            const fetchFnHistoricalByDataRange = getFetchHistoricalByDataRangeFn(props.typeCatagoryName)
            if (fetchFnHistoricalByDataRange) {
                const resultData = await fetchFnHistoricalByDataRange(ukey, fromDateUTC, toDateUTC, dataPeriod)

                if (resultData) {
                    const { avgData, healthScoreGroup, alertReason } = resultData

                    setAverageData(avgData)
                    setHistoricalData(resultData)
                    setHealthScoreDonutList(healthScoreGroup)

                    if (alertReason.length > 0) {
                        let totalCount = 0
                        const newAlertData = []
                        alertReason.forEach(element => {
                            newAlertData.push({ x: element.reason, y: element.count_alert })
                            totalCount = totalCount + element.count_alert
                        })
                        setAlertDataTreemapList(
                            {
                                name: alertReason[0].ukey,
                                result: [{
                                    data: newAlertData
                                }],
                                countAlert: totalCount
                            }
                        )
                    } else {
                        setAlertDataTreemapList(null)
                    }
                }
            }

            setFetchData(false)
            setLoading(false)
        } catch (error) {
            setErrMsg(error)
        }
    }

    const getFetchHistoricalByDataRangeFn = (typeCatagoryName) => {
        switch (typeCatagoryName) {
            case AIR_TYPE:
                return IotDataApi.getHistoricalXWebAirDataByDataRange
            case CDU_TYPE:
                return IotDataApi.getHistoricalXWebCduDataByDataRange
            case REFRIG_TYPE:
                return IotDataApi.getHistoricalXWebDataByDataRange
            case REFRIG_CDU_TYPE:
                return IotDataApi.getHistoricalXWebDataByDataRange
            case METER_TYPE:
                return IotDataApi.getHistoricalXWebMeterDataByDataRange
            default:
                return null
        }
    }

    const renderErr = () => {
        showAlert('error', 'Error', `Error is ${errMsg}`, () => closeAlert())
        setErrMsg('')
    }

    const renderGraphPanel = () => {
        return (
            <Row>
                <Col lg='8'>
                    <HistoricalGraph
                        data={props}
                        historicalData={historicalData}
                        typeCatagoryName={props.typeCatagoryName} />
                </Col>
                <Col lg='4'>
                    <HistoricalPanelRight
                        parameterDetailByGroup={props.parametersDataByGroup}
                        typeCatagoryName={props.typeCatagoryName}
                        averageData={averageData}
                        healthScoreDonutList={healthScoreDonutList}
                        alertDataTreemapList={alertDataTreemapList}
                    />
                </Col>
            </Row >
        )
    }

    return (
        <>
            <Row>
                <div className='period-selector'>
                    <PeriodSelector isShowHourPeriod fromDate={fromDate} toDate={toDate} dataPeriod={dataPeriod}
                        setFromDate={setFromDate} setToDate={setToDate} setDataPeriod={setDataPeriod} setFetchData={setFetchData} />
                </div>
            </Row>
            {isLoading ? <Spinner /> : renderGraphPanel()}
            {errMsg !== '' ? renderErr() : null}
            <div className='equipment-model-detail'>
                <SweetAlert
                    type={alertModel.type}
                    title={alertModel.header || ''}
                    show={alertModel.isShow}
                    onConfirm={alertModel.callback}
                    onCancel={closeAlert}
                    showCancel={alertModel.showCancel}
                    showConfirm={alertModel.type === 'success' ? false : true}
                    reverseButtons
                    cancelBtnBsStyle='danger'
                    timeout={alertModel.type === 'success' ? 2000 : null}
                >
                    <p className='sweet-alert-text'>{alertModel.message}</p>
                </SweetAlert>
            </div>
        </>
    )
}

export default HistoricalTab
